<!--
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-05-17 15:06:08
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2024-12-24 14:35:27
 * @FilePath: /lobby/src/components/DhLazyBanner.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div class="img-continer" @click="onClickBanner">
    <img v-if="isloading" :src="`${resBaseUrl}loading.gif`" alt="" />
    <img v-else :src="imgSrc" width="100%" />
  </div>
</template>
<script>
import { config } from '@/common/config'
import { getLocalStorage, Key } from '@/common/localStorage'
import { BUS, POPUP } from '@/event/EventCenter'
import { useEnvelopeStore } from '@/stores/envelope'
import { useLobbyStore } from '@/stores/lobby'
import { useUserStore } from '@/stores/user'
import { encodeBase64, enterEnvelop } from '@/utils/helper'
import { mapActions, mapState } from 'pinia'
export default {
  name: 'DhLazyBanner',

  data() {
    return {
      isloading: true,
      imgSrc: '',
      resBaseUrl: config.resBaseUrl,
      banner: null
    }
  },
  props: {
    name: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.getBannerUrl()
  },
  computed: {
    ...mapState(useUserStore, ['isLogin'])
  },
  methods: {
    ...mapActions(useLobbyStore, {
      getBannersHomeTop: 'getBannersHomeTop',
      enterGame: 'enterGame'
    }),
    ...mapActions(useEnvelopeStore, { envelope: 'envelope', create: 'create' }),
    getBannerUrl() {
      this.isloading = true
      this.getBannersHomeTop(this.name).then((response) => {
        this.banner = response.banners[0]
        if (this.banner) {
          console.log('bannerUrl: ====>>>>>', response.banners[0].cover)
          this.imgSrc = response.banners[0].cover
          this.isloading = false
        }
      })
    },
    onClickBanner() {
      if (this.banner && this.banner.cmd == 'game') {
        if (this.isLogin) {
          this.enterGame(parseInt(this.banner.cmdValue)).then((response) => {
            this.$router.push({ name: 'gameView', params: { currentGameUrl: response.url } })
          })
        } else {
          this.$bus.$emit(BUS.SHOW_POPUP, { from: 'gridListGame', to: POPUP.LOGIN, show: true })
        }
      } else if (this.banner && this.banner.cmd == 'h5') {
        window.location.href = this.banner.cmdValue
      } else if (this.banner && this.banner.cmd == 'deeplink') {
        this.$router.replace(`/${this.banner.cmdValue}`)
      } else if (this.banner && this.banner.cmd == 'luckywheel') {
        if (!this.isLogin) {
          this.$bus.$emit(BUS.SHOW_POPUP, { from: 'banner', to: POPUP.LOGIN, show: true })
          return
        }
        const url = `${this.banner.cmdValue}?token=${encodeBase64(getLocalStorage(Key.Token))}`
        this.$router.push({ name: 'gameView', params: { currentGameUrl: url } })
      } else if (this.banner && this.banner.cmd == 'active') {
        if (this.banner.cmdValue == 'redenvelope') {
          enterEnvelop(this.isLogin)
          // //  红包活动
          // if (this.isLogin) {
          //   this.envelope().then((res) => {
          //     if (res.id > 0 && res.status < 3) {
          //       //用户身上有红包 直接进入活动页主页
          //       window.location.href = `${window.envelopeUrl}/?active=${getLocalStorage(Key.Token)}&lang=${getLocale()}&cid=hbzz&channel=web`
          //     } else {
          //       //此时用户身上无红包 自动开启红包动画
          //       this.$bus.$emit(BUS.SHOW_ACTIVE_BOX, { hasOpened: false })
          //     }
          //   })
          // } else {
          //   //弹出活动页注册弹窗
          //   this.$bus.$emit(BUS.SHOW_POPUP, { from: 'gridListGame', to: POPUP.REGISTER, show: true })
          // }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.img-continer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
}
</style>
